import { useEffect } from 'react'
import { Box } from '@chakra-ui/react'
import Header from './Header.jsx'
import Hero from './Hero.jsx'
import ValueProposition from './ValueProposition.jsx'
import HowItWorks from './HowItWorks.jsx'
import Features from './Features.jsx'
import CommunityLandingSection from './CommunityLandingSection.jsx'
import LandingRecursos from './LandingRecursos.jsx'
import Planes from './Planes.jsx'
import CallToAction from './CallToAction.jsx'
import Footer from './Footer.jsx'
import SEO from './SEO.jsx'

const LandingPage = () => {
  useEffect(() => {
    const id = window.location.hash.replace('#', '')
    if (!id) return
    const t = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    }, 80)
    return () => window.clearTimeout(t)
  }, [])

  return (
    <Box>
      <SEO
        title="Para bandas"
        path="/bandas"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            name: 'Cadencya',
            applicationCategory: 'BusinessApplication',
            operatingSystem: 'Web',
            url: 'https://cadencya.com/bandas',
            offers: {
              '@type': 'Offer',
              price: '0',
              priceCurrency: 'EUR',
            },
            description:
              'Toda tu música, en un solo lugar. Sistema para bandas: plantilla, archivo musical, ensayos, actuaciones y web pública. Comunidad como funcionalidad adicional.',
          },
        ]}
      />
      <Header />
      <Hero />
      <ValueProposition />
      <HowItWorks />
      <Features />
      <CommunityLandingSection />
      <LandingRecursos />
      <Planes />
      <CallToAction />
      <Footer />
    </Box>
  )
}

export default LandingPage
